"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buttapietra": {
    "01b801de": [{
      "hkey": "a73de48d",
      "slug": "bovo-marchesino",
      "name": "Bovo-Marchesino",
      "primary": true,
      "skipSearch": false
    }],
    "bovo": [{
      "hkey": "a73de48d",
      "slug": "bovo-marchesino",
      "name": "Bovo-Marchesino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c4f55695": [{
      "hkey": "a73de48d",
      "slug": "bovo-marchesino",
      "name": "Bovo-Marchesino",
      "primary": true,
      "skipSearch": false
    }],
    "marchesino": [{
      "hkey": "a73de48d",
      "slug": "bovo-marchesino",
      "name": "Bovo-Marchesino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buttapietra"
    }]
  }
};
exports["default"] = _default;